import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

const KONAMI = [
  'ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown',
  'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight',
  'b', 'a',
];

const MESSAGES = [
  "CHEATER DETECTED\nTIME WALLET CONFISCATED",
  "NO CHEAT CODES HERE\nALL TIME MUST BE EARNED",
  "NICE TRY\nBUT TIME IS UNDEFEATABLE",
  "ERROR: EXTRA LIVES\nNOT FOUND",
];

export function KonamiEasterEgg() {
  const [, setSequence] = useState<string[]>([]);
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      setSequence((prev) => {
        const next = [...prev, e.key].slice(-KONAMI.length);
        if (next.join(',') === KONAMI.join(',')) {
          const msg = MESSAGES[Math.floor(Math.random() * MESSAGES.length)];
          setMessage(msg);
          setShow(true);
          setTimeout(() => setShow(false), 3000);
          return [];
        }
        return next;
      });
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  if (!show) return null;

  return (
    <Box
      onClick={() => setShow(false)}
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'rgba(0,0,0,0.85)',
        cursor: 'pointer',
        animation: 'fadeInOut 3s ease forwards',
        '@keyframes fadeInOut': {
          '0%': { opacity: 0 },
          '10%': { opacity: 1 },
          '80%': { opacity: 1 },
          '100%': { opacity: 0 },
        },
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <Typography
          sx={{
            fontFamily: '"VT323", monospace',
            fontSize: 'clamp(2rem, 6vw, 4rem)',
            color: '#b51e1b',
            letterSpacing: 4,
            whiteSpace: 'pre-line',
            lineHeight: 1.3,
            textShadow: '0 0 20px rgba(181,30,27,0.8)',
          }}
        >
          {message}
        </Typography>
        <Typography
          sx={{
            fontFamily: '"VT323", monospace',
            fontSize: '1.2rem',
            color: 'rgba(255,255,255,0.4)',
            letterSpacing: 2,
            mt: 2,
          }}
        >
          [ click to dismiss ]
        </Typography>
      </Box>
    </Box>
  );
}

export default KonamiEasterEgg;
